import { NUMERIC_LOCALE } from './constants';

export const revertNumber = (value: number): number => Math.abs(value) * (value <= 0 ? 1 : -1);

export const priceString = (price: string | number) => `${Number(price).toLocaleString(NUMERIC_LOCALE)} Kč`;
